<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
  >
    <div class="custom-dialog-header" slot="title">
      <span>{{ title }}</span>
      <i class="el-icon-close custom-close-button" @click="handleCancel"></i>
    </div>
    <el-divider class="line"/>
    <div class="upload" v-show="isShow">
      <div class="upload-item">
        <img class="upload-item-img" src="@/assets/img/downLoad.png" alt="">
        <div class="text1">1.下载录入模版</div>
        <div class="text2">点击立即下载，使用最新录入模版</div>
        <!--        <el-button size="mini" type="primary" @click="handleExport">立即下载</el-button>-->
        <el-button size="mini" type="primary" v-if="type === 1" @click="download('1')">
          <!--          租户信息-->
          立即下载
        </el-button>
        <el-button size="mini" type="primary" v-else @click="download('2')">
          <!--          房间表计-->
          立即下载
        </el-button>
      </div>
      <div class="upload-item">
        <img class="upload-item-img" src="@/assets/img/entering.png" alt="">
        <div class="text1">2.上传录入模版</div>
        <div class="text2">使用模版录入信息完成后</div>
        <el-upload v-if="type === 1" action="" class="upload-demo" :show-file-list="false"
                   :before-upload="handleBeforeUpdate">
          <el-button size="mini" type="primary">立即上传</el-button>
        </el-upload>
        <el-upload v-else action="" class="upload-demo" :show-file-list="false"
                   :before-upload="handleBeforeUpdate">
          <el-button size="mini" type="primary">立即上传</el-button>
        </el-upload>
        <!--        <el-upload-->
        <!--            class="upload-demo"-->
        <!--            action="#"-->
        <!--            :on-preview="handlePreview"-->
        <!--            :on-remove="handleRemove"-->
        <!--            :before-remove="beforeRemove"-->
        <!--            :show-file-list="false"-->
        <!--            accept="xlsx"-->
        <!--            :limit="1"-->
        <!--            :on-exceed="handleExceed"-->
        <!--            :file-list="fileList">-->
        <!--          <el-button size="mini" type="primary">立即上传</el-button>-->
        <!--        </el-upload>-->
      </div>
      <div class="warning" v-show="type === 1">对您园区下企业级租户的信息进行维护，个人租户无需额外管理</div>
    </div>
    <div v-show="!isShow" class="success">
      <img class="success-img" src="@/assets/img/success1.png" alt="">
      <div class="success-text1">录入完成</div>
      <div class="success-text2">稍后刷新页面查看</div>
      <div style="margin-bottom: 100rem">
        <el-button v-show="type === 2" size="mini" type="primary" style="width: 100rem" @click="handleAgain">再录一个
        </el-button>
        <el-button v-show="type === 2" size="mini" style="width: 100rem" @click="handleCancel">退出</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import {
  GET_V3_Cost_Export_Meter_Template,
  GET_V3_Cost_Import_Meter_Template,
  UPLOAD_COST_IMPORT_METER_TEMPLATE,
  UPLOAD_COST_IMPORT_ENTERPRISE_TEMPLATE
} from '@/api/billing.js'
import store from "../../../store";
import {api} from "../../../../config";

export default {
  name: "dialogManage",
  // type 1 == '租户管理' 2 == '表计录入'
  props: ['type', 'title', 'getInit'],
  data() {
    return {
      dialogVisible: false,
      isShow: true,
      fileList: []
    }
  },
  methods: {
    download(type) {
      const downloadLink = document.createElement('a');
      let apiUrl = ''
      if (type == '1') {
        apiUrl = `${api}/v3/cost/export/enterprise/template?projectId=1`
      } else {
        apiUrl = `${api}/v3/cost/export/meter/template?projectId=1`
      }

      fetch(apiUrl)
          .then(response => response.blob())
          .then(blob => {
            const objectUrl = URL.createObjectURL(blob);
            downloadLink.href = objectUrl;
            downloadLink.download = type == '2' ? '房间表计信息模板.xlsx' : '租户企业信息模板 ';
            downloadLink.click();
            URL.revokeObjectURL(objectUrl);
          })
          .catch(error => {
            console.error(error);
          });
    },

    handleCancel() {
      this.dialogVisible = false
    },
    // downloadFile(data, filename, type) {
    //   // 创建 Blob 对象
    //   const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    //
    //   // 判断当前浏览器是否是IE，由于IE是没有download 方法的，需要用msSaveBlob() 或 msSaveOrOpenBlob()
    //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //     // 兼容IE
    //     window.navigator.msSaveOrOpenBlob(blob, filename)
    //   } else {
    //     // 创建 URL 对象
    //     const url = URL.createObjectURL(blob);
    //
    //     // 创建链接
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = filename;
    //
    //     // 模拟点击链接进行下载
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //
    //     // 释放 URL 对象
    //     URL.revokeObjectURL(url);
    //   }
    // },
    // 立即下载
    // async handleExport() {
    //   // 房间表计录入
    //   if (this.type === 2) {
    //     try {
    //       const response = await GET_V3_Cost_Export_Meter_Template();
    //       this.downloadFile(response.data, "aaa.xlsx", ""); // 设置文件名为"aaa.xlsx"
    //     } catch (error) {
    //       console.error('下载失败:', error);
    //     }
    //   }
    // },

    // 再录一个
    handleAgain() {
      this.isShow = true
    },

    handleBeforeUpdate(file) {
      console.log(this.type, file)
      switch (this.type) {
        case 1:
          // 租户管理信息
          UPLOAD_COST_IMPORT_ENTERPRISE_TEMPLATE(file).then((res) => {
            console.log(res)
            if (res.data.code == 200) {
              this.$message.success('上传成功！')
              // this.$emit('getInit')
              this.isShow = false
            } else {
              this.$message.error('上传失败！')
            }
            // this.imageUrl = res.data.data.path;
          });
          break
        case 2:
          // 表计录入
          UPLOAD_COST_IMPORT_METER_TEMPLATE(file).then((res) => {
            if (res.data.code == 200) {
              this.$message.success('上传成功！')
              this.$emit('getInit')
              this.isShow = false
            } else {
              this.$message.error('上传失败！')
            }
            // this.imageUrl = res.data.data.path;
          });
          break
        default:
          return
      }

    }

    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    //
    // handlePreview(file) {
    //   console.log(file);
    // },
    //
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    //
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.isShow = true
      }
    }
  }
}
</script>

<style scoped lang="less">
.custom-dialog-header {
  width: 93%;
  padding: 0;
  font-size: 24rem;
  position: absolute;
  top: 16rem;
  left: 24rem;
  //background-color: pink;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    //font-size: 24rem;

    &:hover {
      color: #409eff;
    }
  }
}

.line {
  position: absolute;
  left: 0;
  top: 35rem;
}

.upload {
  display: flex;
  padding: 90rem 0 180rem;
  position: relative;

  .upload-item {
    width: 50%;
    text-align: center;

    .upload-item-img {
      width: 65rem;
      height: 65rem;
    }

    .text1 {
      font-size: 20rem;
      margin-top: 20rem;
    }

    .text2 {
      font-size: 14rem;
      color: #999;
      margin-bottom: 20rem;
    }
  }

  .warning {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 100rem;
    font-size: 15rem;
    color: #666;
  }
}

.success {
  text-align: center;
  padding-top: 70rem;

  .success-img {
    width: 65rem;
    height: 65rem;
  }

  .success-text1 {
    font-size: 20rem;
    margin-top: 10rem;
  }

  .success-text2 {
    font-size: 15rem;
    color: #999;
    margin-bottom: 20rem;
  }
}

</style>